var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWithUsList2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2109 17.3184H17.1693",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 25H25.1953",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30469 17.3184V7.42253C5.30469 3.46419 6.29427 2.47461 10.2526 2.47461",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0964 17.3184V7.42253C25.0964 3.46419 24.1068 2.47461 20.1484 2.47461",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2214 15.7445V19.0002C13.2214 20.9794 12.4297 21.771 10.4505 21.771H8.07552C6.09635 21.771 5.30469 20.9794 5.30469 19.0002V15.7445C5.30469 13.7653 6.09635 12.9736 8.07552 12.9736H10.4505C12.4297 12.9736 13.2214 13.7653 13.2214 15.7445Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0964 15.7445V19.0002C25.0964 20.9794 24.3047 21.771 22.3255 21.771H19.9505C17.9714 21.771 17.1797 20.9794 17.1797 19.0002V15.7445C17.1797 13.7653 17.9714 12.9736 19.9505 12.9736H22.3255C24.3047 12.9736 25.0964 13.7653 25.0964 15.7445Z",
    stroke: "#219EBC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9453 23.125L25.8203 25L23.9453 26.875",
    stroke: "#219EBC",
    strokeWidth: 1.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07031 23.125L5.19531 25L7.07031 26.875",
    stroke: "#219EBC",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithUsList2);
export default __webpack_public_path__ + "static/media/chatWithUsList2.c7be00a3f3d038dc1e4080965d156caf.svg";
export { ForwardRef as ReactComponent };